import axios from "axios";
import baseUrl from "../../config/api.js";
import { addError } from "../layout/layoutActions.js"; // for centralized error handling
import userTypes from "./userTypes.js";
import { addNotification, toggleNotificationBar } from "../notifications/notificationActions.js";
import { changeDeviceLocation } from "../assets/assetsActions.js";
import {store} from "../store.js"
import { toast } from "react-toastify";
import { baseUrlW } from "../../config/api.js";

/// log in (sign in)
export const signInStart = () => ({
  type: userTypes.SIGN_IN_START,
});

export const signInSuccess = (user) => ({
  type: userTypes.SIGN_IN_SUCCESS,
  payload: user,
});

export const signInFailure = () => ({
  type: userTypes.SIGN_IN_FAILURE,
});

// sign in thunk
export const signInStartAsync = (emailAndPassword, navigate, setSubmitting) => {
  return async (dispatch) => {
    dispatch(signInStart());
    try {
      const response = await axios.post(
        `${baseUrl}/trackAPI/auth/signin`,
        emailAndPassword
      );
      localStorage.setItem("userToken", response.data.token);
      dispatch(signInSuccess(response.data));
      console.log("this is user when sign in :",response.data)
      navigate("/dashboard/");
    } catch (error) {
      dispatch(signInFailure());
      dispatch(
        addError(
          error.response?.data.error ||
            "Couldn't reach the server, please check your interent connection or try again later"
        )
      );
      setSubmitting(false);
    }
  };
};

export const signOutStart = () => ({
  type: userTypes.SIGN_OUT_START,
});

export const signOutSuccess = () => ({
  type: userTypes.SIGN_OUT_SUCCESS,
});

export const sessionExpired = () => ({
  type: userTypes.SESSION_EXPIRED,
});

export const signOutFailure = () => ({
  type: userTypes.SIGN_OUT_FAILURE,
});

// Change settings actions

export const changeSettingsStart = () => ({
  type: userTypes.CHANGE_SETTINGS_START,
});

export const changeSettingsSuccess = (settings) => ({
  type: userTypes.CHANGE_SETTINGS_SUCCESS,
  payload: settings,
});

export const changeSettingsFailure = () => ({
  type: userTypes.CHANGE_SETTINGS_FAILURE,
});

// sign up thunk
export const signOutStartAsync = (navigate) => {
  return (dispatch) => {
    dispatch(signOutStart());
    try {
      if(store.socket){
        store.socket.close();
        store.socket=null;
      }
      dispatch(signOutSuccess());
      localStorage.removeItem("userToken");
      dispatch({ type: "CLOSE_DROPDOWN" });
      navigate("/login");
    } catch (error) {
      dispatch(signOutFailure());
      dispatch(
        addError(
          error.response?.data.error ||
            "Couldn't reach the server, please check your interent connection or try again later"
        )
      );
    }
  };
};

// Change user settings thunk
export const changeUserSettingsAsync = (userId, settings, token) => {
  return async (dispatch) => {
    dispatch(changeSettingsStart());
    try {
      const response = await axios.put(
        `${baseUrl}/trackAPI/users/${userId}/changeSettings`,
        settings,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(changeSettingsSuccess(settings));
    } catch (error) {
      dispatch(changeSettingsFailure());
      alert("Failed to save changes", error.message);
    }
  };
};

// Helper function to show notification toast
const showNotificationToast = (content, dispatch) => {
  // Create toast with a render function approach instead of JSX
  toast((
    // This will be rendered by react-toastify when needed
    function ToastContent() {
      return React.createElement('div', 
        { 
          style: {padding:'8px 15px'}, 
          onClick: () => dispatch(toggleNotificationBar())
        }, 
        [
          React.createElement('strong', 
            { 
              style: { display: 'block', marginBottom: '10px' }, 
              key: 'title' 
            }, 
            'New Notification'
          ),
          content
        ]
      );
    }
  ), { icon: false });
};

export const initializeWebSocket = () => {
  return (dispatch, getState) => {
    const token = getState().user.currentUser?.token;
    if (!token) return;
    const socket = new WebSocket(`${baseUrlW}/?token=${token}`);
    socket.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    socket.onmessage = async (event) => {
      const data = JSON.parse(event.data);
      if (data.content) {
        dispatch(addNotification(data));
        const {notificationsOpen} = getState().notifications;
        if(!notificationsOpen){
          showNotificationToast(data.content, dispatch);
        }
      } else if (data.payload) {
        dispatch(changeDeviceLocation(data.deviceId, data.payload));
        console.log("location changed")
      }
    };

    socket.onclose = (event) => {
      console.log("Disconnected from WebSocket server");
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    // Store socket reference globally (optional, if you need to close it later)
    store.socket = socket;
  };
}; 